import { useState, useEffect } from 'react';

interface NavigationPosition {
  top: number;
  height: number;
}

/**
 * Custom hook to read the current position and height of NavigationScroll
 * Returns Navigation's dynamic top value and its responsive height
 * @returns Object with top position and height of NavigationScroll element
 */
const useScrollPastNavHeight = (): NavigationPosition => {
  const [navigationTop, setNavigationTop] = useState(0);
  const [navigationHeight, setNavigationHeight] = useState(120); // Default: wide desktop

  useEffect(() => {
    const handleScroll = () => {
      // Get the NavigationScroll element to read its position and height
      const navElement = document.querySelector('.NavigationScroll');

      if (navElement instanceof HTMLElement) {
        // Read the inline style.top value from NavigationScroll
        // Range: 0 (fully visible) to -height (fully hidden)
        const topValue = parseInt(navElement.style.top, 10) || 0;
        const height = navElement.offsetHeight;

        setNavigationTop(topValue);
        setNavigationHeight(height);
      }
    };

    // Call immediately to set height on mount
    handleScroll();

    // Add scroll listener for subsequent updates
    window.addEventListener('scroll', handleScroll);

    // Cleanup listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { top: navigationTop, height: navigationHeight };
};

export default useScrollPastNavHeight;
